











































































import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { TabContainableMixin } from "../../system/mixins";
import { ReceptionDispInfo } from "../../../domain/workflow";
import { ReceptionCommentDispInfo } from "../../../domain/workflow/reference";
import { ReceptionCommentSet } from "../../../domain/workflow/reception";

import CommentListTable from "../lists/tables/CommentListTable.vue";
import CommentsMixedListTable from "../lists/tables/CommentsMixedListTable.vue";
import TabSelector from "../../system/selectors/TabSelector.vue";
import CommentDialog from "../dialogs/CommentDialog.vue";


@Component({
  components: {
    TabSelector,
    CommentListTable,
    CommentsMixedListTable,
  },
})
export default class CommentTabSelector extends Mixins(TabContainableMixin) {
  static readonly Tabs: {[key: string]: any} = {
    comment: {
      name: "コメント",
      description: "",
    },
  };

  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly commentTab: any = CommentTabSelector.Tabs.comment;

  @Prop()
  detailId: number;

  @Prop()
  isRegistered: boolean;

  @Prop()
  isDeleted: boolean;

  @Prop()
  commentSet: ReceptionCommentSet;

  @Prop()
  labelSetting: ReceptionDispInfo;

  @Prop()
  commentSetting: ReceptionCommentDispInfo;

  @Prop({ default: "horizontal" })
  tabLayout: "vertical" | "horizontal";

  @Prop({ default: false })
  shouldShowSwitcher: boolean;

  @Prop({ default: false })
  shouldShowAutomatically: boolean;

  @Prop({ default: false })
  automaticallyChecked: boolean;

  @Prop()
  commentDialog: CommentDialog;

  @Prop({ default: false })
  isReadOnly: false;

  @Emit()
  commentUpdated(): void {}

  @Emit()
  automaticallyUpdated(): void {}

  @Emit()
  splitUpdated(): void {}

  mounted(): void {
    this.tabs = [
      CommentTabSelector.Tabs.comment,
    ];

    this.selectedTab = this.tabs[0];
  }

  get shouldShowCommentsMixed(): boolean {
    return this.commentSetting && this.commentSetting.shouldShowCommentsMixed;
  }

  get tabPosition(): "left" | "top" {
    return this.tabLayout === "horizontal"
      ? "left"
      : "top";
  }

  get toolTipPosition(): "right" | "left" {
    return this.tabLayout === "horizontal"
      ? "right"
      : "left";
  }

  get tabContainerTransitionName(): "expand-width" | "expand-height" {
    return this.tabLayout === "horizontal"
      ? "expand-width"
      : "expand-height";
  }

  get tabContainerClass(): "vertical" | "horizontal" {
    return this.tabLayout === "horizontal"
      ? "vertical"
      : "horizontal";
  }

  get automaticallyClass(): string {
    return this.automaticallyChecked
      ? "checked"
      : "";
  }

  get splitClass(): string {
    return this.tabLayout === "horizontal"
      ? "vertical"
      : "horizontal";
  }

  get automaticallyDescription(): string[] {
    return ["タブの表示位置を画面幅に応じて自動的に", "切り替えるかどうかを指定します。"];
  }

  get splitDescription(): string {
    return "タブの表示位置を変更します。";
  }

 // -------------------Emitで呼ばれる---------------------------------

  // 子どもからコメント更新通知がきました
  onCommentUpdated(): void {
    this.commentUpdated();
  }
}
